import React from "react";
import { Link } from "react-router-dom";
import { Calendar } from "lucide-react";
import { useEvents } from "../hooks/useEvents";
import { format } from "date-fns";

const EventsPreview: React.FC = () => {
  const { data: events = [] } = useEvents();
  
  // Take only the first 3 events for preview
  const previewEvents = events.slice(0, 3);

  return (
    <section className="section-padding bg-lounge-dark">
      <div className="container-custom">
        <h2 className="section-title text-center">Upcoming Events</h2>
        <p className="section-subtitle text-center max-w-3xl mx-auto">
          Don't miss out on our exciting events. From DJ nights to themed parties, there's always something happening at Seven8Nine.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {previewEvents.map((event) => (
            <div 
              key={event.id}
              className="bg-lounge-charcoal rounded-lg overflow-hidden border border-lounge-gold/20 hover:border-lounge-gold/50 transition-all duration-300"
            >
              <div className="bg-lounge-gold text-lounge-dark p-3 flex items-center justify-between">
                <span className="font-display font-semibold">
                  {format(new Date(event.date), "MMMM d, yyyy")}
                </span>
                <Calendar size={18} />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-display font-semibold mb-2 text-lounge-gold">{event.title}</h3>
                <p className="text-lounge-light/60 mb-4">
                  {format(new Date(`2000-01-01T${event.start_time}`), "h:mm a")} - {format(new Date(`2000-01-01T${event.end_time}`), "h:mm a")}
                </p>
                <p className="text-lounge-light/80 mb-4">{event.description}</p>
                <Link to={`/events#event-${event.id}`} className="text-lounge-gold hover:text-lounge-light font-semibold transition-colors">
                  Learn More &rarr;
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/events" className="btn-primary">View All Events</Link>
        </div>
      </div>
    </section>
  );
};

export default EventsPreview;
